import { Button } from 'components/universal/button';
import Heading from 'components/universal/heading';
import Paragraph from 'components/universal/paragraph';
import { PATHS } from 'constants/routes';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import cls from './reset-access.module.scss';

export const ResetAccessPageView = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const onBack = () => {
        navigate(PATHS.HOME);
    }

    return (
        <div
            className={cls.wrapper}
        >
            <Heading
                className={cls.heading}
                headingLevel="h1"
                headingStyle="h2"
            >
                {t('resetPassword.titleResetAccess')}
            </Heading>
            <Paragraph className={cls.paragraph}>
                {t('resetPassword.desc1ResetAccess')}
            </Paragraph>
            <Button 
                className={`${cls.button} mx-auto mb-5`} 
                styleType="border"
                onClick={onBack}
            >
                {t('resetPassword.goBackButtonResetAccess')}
            </Button>
        </div>
    );
};


